import { Component } from 'react';
import cx from 'classnames';

import styles from '../../styles/sticky.scss';

interface Props {
  className?: string;
  hideAfter?: string;
  disableDesktop?: boolean;
  marginLeftRequired?: boolean;
  fullWidth?: boolean;
  noWidth?: boolean;
  hideShadow?: boolean;
  hideAfterOffset?: number;
  stickyBottom?: boolean;
  stickyOffset?: number;
  changeSticky?: any;
  noPadding: boolean;
  left?: string;
  disableMobile?: boolean;
  zIndex?: number;
  isReload?: boolean;
}

interface State {
  sticky: boolean;
  buffer: any;
}

class Sticky extends Component<Props, State> {
  private sticky: any;
  // private stickyBar: any;

  constructor(props: any) {
    super(props);
    this.state = {
      sticky: false,
      buffer: {},
    };
  }

  private checkPosition = () => {
    const { sticky } = this.state;
    const { hideAfter, hideAfterOffset, stickyOffset } = this.props;
    const stickyBounds = this.sticky.getBoundingClientRect();
    const headerHeight = document
      .getElementById('app-header')
      .getBoundingClientRect().height;
    if (stickyBounds.top + (stickyOffset || 0) <= headerHeight) {
      if (hideAfter) {
        const el = document
          .querySelector(`.${hideAfter}-block`)
          .getBoundingClientRect();
        const { top, height } = el;
        if (-top + hideAfterOffset > height) {
          this.setState({ sticky: false });
        } else {
          this.setState({ sticky: true });
        }
      } else {
        this.setState({
          sticky: true,
        });
      }
    } else if (stickyBounds.top > headerHeight && sticky) {
      this.setState({ sticky: false });
    }
  };

  private handleBuffer = (isReloading?: boolean) => {
    const ele = isReloading ? this.sticky.children[0] : this.sticky;
    const stickyBarBounds = (ele && ele.getBoundingClientRect()) || {};
    this.setState({ buffer: stickyBarBounds });
  };

  private loadSticky(isReloading?: boolean) {
    this.handleBuffer(isReloading);
    this.checkPosition();
  }

  public componentDidMount() {
    this.loadSticky();
    document.addEventListener('scroll', this.checkPosition);
    window.addEventListener('resize', () => this.handleBuffer());
  }

  public componentDidUpdate(prevProps: Props, prevState: State) {
    const { sticky } = this.state;
    const { changeSticky, isReload } = this.props;
    if (
      prevState.sticky !== sticky &&
      changeSticky &&
      typeof changeSticky === 'function'
    ) {
      changeSticky(sticky);
    }

    if (isReload && isReload !== prevProps.isReload) {
      this.loadSticky(isReload);
    }
  }

  public componentWillUnmount() {
    document.removeEventListener('scroll', this.checkPosition);
    window.removeEventListener('resize', () => this.handleBuffer());
  }

  public render() {
    const { sticky, buffer } = this.state;
    const { height, width, left } = buffer;
    const {
      className,
      disableDesktop,
      marginLeftRequired,
      fullWidth,
      noWidth,
      hideShadow,
      stickyBottom,
      noPadding,
      left: leftPos,
      disableMobile,
      zIndex,
    } = this.props;
    const finalWidth = fullWidth ? `100%` : `${width}px`;
    const inlineStyles = {};
    if (leftPos) {
      inlineStyles.left = leftPos;
    }
    return (
      <div
        className={cx(styles.sticky, { [styles.fixed]: sticky }, className)}
        ref={(stickyRef: any) => (this.sticky = stickyRef)}
        style={{
          height: `${height}px`,
        }}
      >
        <div
          className={cx(styles['sticky-background'], {
            [stickyBottom ? styles['fixed-bottom'] : styles.fixed]: sticky,
            [styles['sticky-on-mobile']]: disableDesktop,
            [styles['disable-sticky-mobile']]: disableMobile,
          })}
          style={{
            minHeight: `${height - 1}px`,
            zIndex: zIndex || 10,
            ...inlineStyles,
          }}
        >
          <div
            className={cx(
              styles['sticky-bar'],
              { [styles.fixed]: sticky },
              {
                [styles.shadow]: !hideShadow,
                [styles.padding]: !noPadding,
              }
            )}
            ref={(stickyBar: any) => (this.stickyBar = stickyBar)}
            style={{
              width: `${noWidth ? 'auto' : finalWidth}`,
              marginLeft: `${sticky && marginLeftRequired ? left : 0}px`,
              height: 'inherit',
            }}
          >
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default Sticky;



// WEBPACK FOOTER //
// ./components/ui/sticky.tsx